import { render, staticRenderFns } from "./remind.vue?vue&type=template&id=add60d08&scoped=true"
import script from "./remind.vue?vue&type=script&setup=true&lang=js"
export * from "./remind.vue?vue&type=script&setup=true&lang=js"
import style0 from "./remind.vue?vue&type=style&index=0&id=add60d08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add60d08",
  null
  
)

export default component.exports